import React from 'react';
import { IDisburseAllDisbursementData } from 'types/order/escrow/IDisburseAllDisbursementData';
import { Currency } from 'ui-toolkit';

export const Totals = ({ disbursements }: { disbursements: IDisburseAllDisbursementData[] }) => {
  const total = disbursements.reduce((acc, curr) => acc + (curr.disbursement.amountCents ?? 0), 0);
  return (
    <div className="mt-2 flex basis-full justify-end gap-4 pr-6 text-base font-semibold">
      <span>Total:</span>
      <Currency className="flex text-left" value={total} valueIsCents={true} />
    </div>
  );
};
